import { communityPosts } from "@/mocks/homeNews";

export default function Community() {
  return (
    <section id="chat" className="scroll-mt-24 bg-background-950">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-16">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-background-950">
              <i className="ri-chat-heart-line" /> 瓜田热聊
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-background-50 md:text-3xl">
              评论区已经蹲满，就差你一个
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-background-300">
              追剧、追综、吃新瓜，说出来一起唠。帖子由瓜友自发讨论，也欢迎你随时加入战场。
            </p>
          </div>
          <button
            type="button"
            className="shrink-0 cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition hover:bg-primary-400 dark:text-foreground-950"
          >
            <i className="ri-edit-2-line mr-1" /> 我也发一条
          </button>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          {communityPosts.map((p) => (
            <article key={p.id} className="flex flex-col rounded-2xl border border-background-800 bg-background-900 p-5 transition hover:border-accent-500/50">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-700 font-heading text-base font-bold text-background-50">
                  {p.author.slice(0, 1)}
                </span>
                <div className="flex flex-col">
                  <span className="text-sm font-semibold text-background-50">{p.author}</span>
                  <span className="text-xs text-background-400">{p.tag}</span>
                </div>
                <i className="ri-verified-badge-fill ml-auto text-lg text-accent-500" />
              </div>
              <p className="mt-4 flex-1 text-sm leading-relaxed text-background-200">{p.text}</p>
              <div className="mt-5 flex items-center gap-4 border-t border-background-800 pt-4 text-sm text-background-300">
                <button type="button" className="flex cursor-pointer items-center gap-1.5 transition hover:text-primary-400">
                  <i className="ri-heart-3-line" /> {p.likes.toLocaleString()}
                </button>
                <button type="button" className="flex cursor-pointer items-center gap-1.5 transition hover:text-primary-400">
                  <i className="ri-chat-3-line" /> {p.comments}
                </button>
                <button type="button" className="ml-auto cursor-pointer transition hover:text-primary-400">
                  <i className="ri-share-forward-line" />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}